export default (sortBy = [], rowsPerPage = 5, sortDesc = []) => {
	return {
		rowsPerPage: rowsPerPage ? rowsPerPage : 5,
		page: 1,
		sortBy: [...sortBy],
		sortByDefault: [...sortBy],
		sortDesc: [...sortDesc],
		sortDescDefault: [...sortDesc],
	}
}
